import { useEffect, useState } from "react";

import { useGetCurfewsQuery } from "@/app/api/slices/curfewsApiSlice";
import { Skeleton } from "@/components/ui/skeleton";
import { useCurrentVesselId } from "@/hooks/useCurrentVesselId";
import { useDateFormatter } from "@/hooks/useDateFormatter";
import { CurfewEntry } from "@/types/Curfew";
import { ClockAlert } from "lucide-react";

export const CurfewTerminal = () => {
	const vesselId = useCurrentVesselId();
	const { format } = useDateFormatter();

	const {
		data: curfewsResponse,
		isLoading: isLoadingCurfews,
		isFetching: isFetchingCurfews,
	} = useGetCurfewsQuery(
		{ vesselId },
		{
			pollingInterval: 5 * 60000, // 5 minute
		},
	);

	const [nextCurfew, setNextCurfew] = useState<CurfewEntry>();

	useEffect(() => {
		if (curfewsResponse?.data?.length) {
			const now = new Date();

			const upcomingCurfews = curfewsResponse.data
				.filter((curfew: CurfewEntry) => new Date(`${curfew.date}T${curfew.time}`) > now)
				.sort(
					(a: CurfewEntry, b: CurfewEntry) =>
						new Date(`${a.date}T${a.time}`).getTime() - new Date(`${b.date}T${b.time}`).getTime(),
				);

			if (upcomingCurfews.length) {
				setNextCurfew(upcomingCurfews[0]);
			} else {
				setNextCurfew(undefined);
			}
		}
	}, [curfewsResponse]);

	if (isLoadingCurfews || isFetchingCurfews) return <Skeleton className="h-5 w-[222px]" />;

	return (
		<div>
			{nextCurfew ? (
				<div className="flex items-center justify-end gap-2">
					<ClockAlert className="text-red-600" />
					<span>
						<span className="font-semibold">Next Curfew:</span> {format(nextCurfew.date)}{" "}
						{nextCurfew.time.split(":")[0]}:{nextCurfew.time.split(":")[1]}
					</span>
				</div>
			) : null}
		</div>
	);
};
